import { useCallback } from 'react';
import type { DraftFormState } from '@client/state/draft-form-state.hook';
import type { TemplateType } from '@server/trading-templates/schemas/input.schema';
import { useWindow } from '@client/window/window.hook';
import type { SaveTradingTemplateFormState } from '../save-trading-template-form';
import { buildTemplateConfig } from '../template-config.utils';
import { useTemplateSave } from '../template-save.hook';

export const useModifyTemplate = () => {
  const { openWindow, closeWindow } = useWindow();
  const { saveTemplate } = useTemplateSave();

  const onModify = useCallback(
    (
      draftState: DraftFormState,
      timeframeIndex: number,
      templateType: TemplateType
    ) =>
      (templateId: string, templateName: string) => {
        const handleSubmit = async (formState: SaveTradingTemplateFormState) => {
          try {
            const config = buildTemplateConfig(
              draftState,
              templateType,
              timeframeIndex
            );

            await saveTemplate({
              templateId,
              name: formState.name,
              config,
              invalidateDefaultTemplates: true
            });

            closeWindow('SaveTradingTemplateForm');
          } catch {
            // saveTemplate already handles notifications for persistence failures.
          }
        };

        openWindow({
          type: 'SaveTradingTemplateForm',
          sizePreset: 'form',
          componentProps: {
            onSubmit: handleSubmit,
            initialValues: { name: templateName },
            submitLabel: 'Update'
          }
        });
      },
    [closeWindow, openWindow, saveTemplate]
  );

  return { onModify };
};
